export default "__VITE_ASSET__CWpKChk9__"